import React, { useRef, useEffect } from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import {
  fabClasses,
  IconButton,
  Skeleton,
  TextField,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { usePrompt } from "../../Hooks/useBlocker";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import { DragDropContext } from "react-beautiful-dnd";
import { Draggable } from "react-beautiful-dnd";
import { Droppable } from "react-beautiful-dnd";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

const Actions = ({
  editIndex,
  index,
  validate,
  row,
  options,
  setSaved,
  rowCopy,
}) => {
  return (
    <TableCell
      sx={(theme) => ({
        minWidth: options.actionsMinWidth || options.minColumnWidth || "170px",
        width: "100%",
        backgroundColor: "white",
        [theme.breakpoints.up("md")]: {
          position: "sticky",
          right: 0,
        },
        borderLeft: "dotted 1px gray !important",
      })}
      component="th"
      scope="row"
    >
      {options?.save && editIndex.rowIndex === index && (
        <Tooltip title="Save">
          <IconButton
            id="button"
            onClick={(e) => {
              e.stopPropagation();

              validate(row);
            }}
          >
            <SaveIcon />
          </IconButton>
        </Tooltip>
      )}

      {options?.delete && (
        <Tooltip title="Delete">
          <IconButton
            id="button"
            onClick={(e) => {
              e.stopPropagation();

              setSaved(true);

              options.delete(row);
            }}
          >
            <DeleteIcon sx={{ color: "error.light" }} />
          </IconButton>
        </Tooltip>
      )}

      {!options?.check ? null : (
        <Tooltip title="Check">
          <CheckIcon
            fontSize="large"
            sx={{ color: "primary.light" }}
            onClick={() => {
              // setCurrentData(tableMeta);
              //open dialog
              options.check(row);
            }}
          />
        </Tooltip>
      )}

      {!options?.uncheck ? null : (
        <Tooltip title="Delete">
          <CloseIcon
            fontSize="large"
            sx={{ marginLeft: "20px", color: "error.light" }}
            onClick={() => {
              // setCurrentData(tableMeta);
              //open dialog
              options.uncheck(row);
            }}
          />
        </Tooltip>
      )}

      {
        !options?.select?.(row) ? null : row.selected ? (
          <CheckBoxIcon
            fontSize="large"
            key={index}
            sx={{ marginLeft: "20px" }}
            onClick={() => {
              // setCurrentData(tableMeta);
              //open dialog
              options.selectFunc(row);
            }}
          />
        ) : (
          <CheckBoxOutlineBlankIcon
            fontSize="large"
            key={index}
            sx={{ marginLeft: "20px" }}
            onClick={() => {
              // setCurrentData(tableMeta);
              //open dialog
              options.selectFunc(row);
            }}
          />
        )
        // <Tooltip title="Select">
        // </Tooltip>
      }

      {options?.open && (
        <Tooltip title="Open">
          <IconButton onClick={() => options?.open?.(rowCopy, row)}>
            <OpenInNewIcon sx={{ color: "primary.light" }} />
          </IconButton>
        </Tooltip>
      )}
    </TableCell>
  );
};

function Body({ rows, filteredColumns, columns, options }) {
  const [editIndex, setEditIndex] = useState(false);
  const [rowCopy, setRowCopy] = useState(false);
  const [saved, setSaved] = useState(true);

  usePrompt("If you leave without saving you will loss your data?", !saved);

  // console.log(rows, columns);
  const previousValue = useRef(null);

  const currentFocus = useRef(null);

  const filter = createFilterOptions();

  useEffect(() => {
    previousValue.current = editIndex;
  }, [editIndex]);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // console.log(rowCopy);

    if (!rowCopy) return;

    // options?.onChange?.(rows, rowCopy);
  }, [rowCopy]);

  const validate = (row) => {
    function save() {
      options?.save(rowCopy, row);
      // console.log("validate1");

      setSaved(true);

      setEditIndex(false);

      setRowCopy(false);
    }

    function fillRequerments() {
      alert("Please fill in all required information");

      // console.log(currentFocus, rowCopy);

      setTimeout(() => currentFocus.current.focus(), 500);

      setSaved(false);
    }

    if (row[options.singleRowId] === true) {
      if (row[options.singleRow]) {
        save();
      } else {
        fillRequerments();
      }
    } else {
      const filledRequerments = filteredColumns
        .filter(
          (item) => item.required === true && item.id !== options.singleRowId
        )
        .map((column, i) => {
          if (rowCopy[column.id]) {
            return true;
          } else {
            return false;
          }
        });

      if (!filledRequerments.includes(false)) {
        save();
      } else {
        fillRequerments();
      }
    }
  };

  function onDragEnd(r, rowCopy) {
    // console.log(r);
    options.onDragEnd?.(r);
  }

  return (
    <DragDropContext onDragEnd={(r) => onDragEnd(r)}>
      <TableBody
        sx={{
          width: "100%",
          height: "100%",
          minHeight: 0,
        }}
      >
        <Droppable droppableId={"1"} key={1} index={1}>
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              <div>
                {rows?.map((row, index) => {
                  // console.log(row[options.singleRowId]);
                  if (row[options.singleRowId]) {
                    return (
                      <Draggable
                        key={index}
                        draggableId={String(row["draggableId"])}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <TableRow
                            key={index}
                            sx={{
                              display: "flex",
                              justifyContent: "spaceAround",
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                            onClick={() => {
                              setRowCopy(row);
                            }}
                          >
                            {options.dragable && (
                              <TableCell
                                sx={{ width: "18px" }}
                                {...provided.dragHandleProps}
                                handle
                              >
                                <DragHandleIcon />
                              </TableCell>
                            )}

                            <TableCell
                              sx={{
                                minWidth: options.minColumnWidth || "100%",
                                minHeight: "50px",
                                width: "100%",
                              }}
                              component="th"
                              scope="row"
                              key={index}
                              onClick={(e) => {
                                if (options.editable === false) return;

                                if (editIndex.rowIndex === index) {
                                  e.stopPropagation();
                                }

                                setEditIndex({
                                  rowIndex: index,
                                  columnIndex: 0,
                                });
                              }}
                            >
                              <TextField
                                value={row[options.singleRow]}
                                onChange={(e) =>
                                  setRowCopy({
                                    ...rowCopy,
                                    [options.singleRow]: e.target.value,
                                  })
                                }
                                multiline
                                error={
                                  columns.find(
                                    (item) => item.id === options.singleRowId
                                  )?.required === true && saved === false
                                }
                                size="small"
                                sx={{ width: "100%" }}
                                autoFocus={true}
                                id={`cell${index}`}
                                inputRef={currentFocus}
                                onBlur={(e) => {
                                  if (e.relatedTarget?.id === e.target?.id)
                                    e.stopPropagation();

                                  if (e.relatedTarget?.id === "button") return;

                                  if (e.relatedTarget?.id.includes("cell")) {
                                    // console.log("related");
                                    e.relatedTarget.focus();
                                  } else {
                                    validate(row);
                                  }
                                }}
                              />
                            </TableCell>

                            <Actions
                              editIndex={editIndex}
                              index={index}
                              validate={validate}
                              row={row}
                              options={options}
                              setSaved={setSaved}
                              rowCopy={rowCopy}
                            />
                          </TableRow>
                        )}
                      </Draggable>
                    );
                  } else if (columns.customRow) {
                    return row.customRow(row, index);
                  } else {
                    return (
                      <Draggable
                        key={index}
                        draggableId={String(row["draggableId"])}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <TableRow
                            key={index}
                            sx={{
                              display: "flex",
                              justifyContent: "spaceAround",
                              borderBottom: "solid 1px #e0e0e0 !important",
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                            onClick={() => {
                              setRowCopy(row);
                            }}
                            {...provided.draggableProps}
                            ref={provided.innerRef}
                            isDragging={snapshot.isDragging}
                            className="flex ma2 items-center"
                          >
                            {options.dragable && (
                              <TableCell
                                sx={{ width: "18px" }}
                                {...provided.dragHandleProps}
                                handle
                              >
                                <DragHandleIcon />
                              </TableCell>
                            )}
                            {filteredColumns.map((column, i) => {
                              const updatedColumn = columns.find(
                                (item) => item.id === column.id
                              );

                              if (column.view === false) {
                                return null;
                              } else if (column.customCell) {
                                return (
                                  <TableCell
                                    sx={{
                                      minWidth:
                                        column.minWidth ||
                                        options.minColumnWidth ||
                                        "150px",
                                      minHeight: "50px",
                                      alignSelf: "center",
                                      border: "none !important",
                                      width: "100%",
                                    }}
                                    component="th"
                                    scope="row"
                                  >
                                    {column.customCell(row, index) || null}
                                  </TableCell>
                                );
                              } else {
                                return (
                                  <TableCell
                                    sx={{
                                      minWidth:
                                        column.minWidth ||
                                        options.minColumnWidth ||
                                        "150px",
                                      minHeight: "50px",
                                      alignSelf: "center",
                                      border: "none !important",
                                      width: "100%",
                                    }}
                                    component="th"
                                    scope="row"
                                    key={
                                      row.uniqueCode + i + index || i + index
                                    }
                                    onClick={(e) => {
                                      if (
                                        options.editable === false ||
                                        column.edit === false
                                      )
                                        return;

                                      if (editIndex.rowIndex === index) {
                                        e.stopPropagation();
                                      }

                                      setEditIndex({
                                        rowIndex: index,
                                        columnIndex: i,
                                      });
                                    }}
                                  >
                                    {options?.isLoading && <Skeleton />}

                                    {(editIndex.rowIndex === index ||
                                      options.allwaysEdit) &&
                                      column.edit?.(row) !== false &&
                                      column.edit?.(row) !== null &&
                                      (column.editComponent === undefined ||
                                        column.editComponent ===
                                          "textField") && (
                                        <TextField
                                          value={row[column.id]}
                                          onChange={(e) => {
                                            options.onChange(e, row, column.id);
                                            if (column.type === "number") {
                                              setRowCopy({
                                                ...rowCopy,
                                                [column.id]: parseFloat(
                                                  e.target.value
                                                ),
                                              });
                                            } else {
                                              setRowCopy({
                                                ...rowCopy,
                                                [column.id]: e.target.value,
                                              });
                                            }
                                          }}
                                          type={column.type}
                                          step="0.00"
                                          error={
                                            column.required === true &&
                                            saved === false &&
                                            !rowCopy[column.id]
                                          }
                                          autoFocus={
                                            editIndex.rowIndex === index &&
                                            editIndex.columnIndex === i
                                              ? true
                                              : false
                                          }
                                          inputRef={
                                            editIndex.rowIndex === index &&
                                            !rowCopy[column.id]
                                              ? currentFocus
                                              : null
                                          }
                                          id={`cell${index}`}
                                          size="small"
                                          info={{ id: "cell", index, i }}
                                          onBlur={(e) => {
                                            if (
                                              e.relatedTarget?.id ===
                                              e.target?.id
                                            )
                                              e.stopPropagation();

                                            if (
                                              e.relatedTarget?.id === "button"
                                            )
                                              return;

                                            if (
                                              e.relatedTarget?.id.includes(
                                                "cell"
                                              )
                                            ) {
                                              // console.log("related");
                                              e.relatedTarget.focus();
                                            } else {
                                              validate(row);
                                            }
                                          }}
                                        />
                                      )}
                                    {editIndex.rowIndex === index &&
                                      column.edit?.(row) !== false &&
                                      column.edit?.(row) !== null &&
                                      column.editComponent?.type ===
                                        "selectField" && (
                                        <Autocomplete
                                          value={rowCopy[column.id]}
                                          onBlur={(e) => {
                                            // console.log("blur", e);
                                            if (
                                              e.relatedTarget?.id ===
                                              e.target?.id
                                            )
                                              e.stopPropagation();

                                            if (
                                              e.relatedTarget?.id === "button"
                                            )
                                              return;

                                            if (
                                              e.relatedTarget?.id.includes(
                                                "cell"
                                              )
                                            ) {
                                              // console.log("related");
                                              e.relatedTarget.focus();
                                            } else {
                                              validate(row);
                                            }
                                          }}
                                          id={`cell${index}`}
                                          size="small"
                                          InputProps={{
                                            startAdornment: (
                                              <InputAdornment position="start">
                                                {
                                                  updatedColumn.editComponent
                                                    ?.label
                                                }
                                              </InputAdornment>
                                            ),
                                          }}
                                          autoSelect={true}
                                          sx={{ minWidth: options?.width }}
                                          selectOnFocus
                                          clearOnBlur
                                          handleHomeEndKeys
                                          onOpen={(e) => options.onOpen?.()}
                                          onChange={(e, newValue) => {
                                            setRowCopy({
                                              ...rowCopy,
                                              [column.id]: newValue,
                                            });

                                            updatedColumn.editComponent?.onChange?.(
                                              newValue,
                                              setRowCopy,
                                              rowCopy
                                            );
                                          }}
                                          isOptionEqualToValue={(
                                            option,
                                            value
                                          ) =>
                                            option[
                                              updatedColumn.editComponent?.id
                                            ] ===
                                            value[
                                              updatedColumn.editComponent?.id
                                            ]
                                          }
                                          options={
                                            updatedColumn.editComponent
                                              ?.values || []
                                          }
                                          getOptionLabel={(option) => {
                                            // Value selected with enter, right from the input
                                            if (typeof option === "string") {
                                              return option;
                                            }
                                            // Add "xxx" option created dynamically
                                            if (option.inputValue) {
                                              return option.inputValue;
                                            }
                                            // Regular option
                                            return option.title;
                                          }}
                                          filterOptions={(
                                            filterOptions,
                                            params
                                          ) => {
                                            const filtered = filter(
                                              filterOptions,
                                              params
                                            );

                                            const { inputValue } = params;

                                            // Suggest the creation of a new value
                                            const isExisting =
                                              filterOptions.some(
                                                (option) =>
                                                  inputValue === option.title
                                              );

                                            if (
                                              inputValue !== "" &&
                                              !isExisting &&
                                              options.add
                                            ) {
                                              filtered.push({
                                                inputValue,
                                                title: (
                                                  <Box
                                                    sx={{
                                                      color: "primary.light",
                                                      marginLeft: "10px",
                                                    }}
                                                  >{`Create "${inputValue}"`}</Box>
                                                ),
                                              });
                                            }

                                            return filtered;
                                          }}
                                          renderOption={(props, option) => (
                                            <li {...props}>{option.title}</li>
                                          )}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              onFocus={() => {
                                                column.editComponent.onFocus?.(
                                                  rowCopy
                                                );
                                              }}
                                              error={
                                                column.required === true &&
                                                saved === false &&
                                                !rowCopy[column.id]
                                              }
                                              autoFocus={
                                                editIndex.rowIndex === index &&
                                                editIndex.columnIndex === i
                                                  ? true
                                                  : false
                                              }
                                              inputRef={
                                                editIndex.rowIndex === index &&
                                                !rowCopy[column.id]
                                                  ? currentFocus
                                                  : null
                                              }
                                              sx={{
                                                minWidth: options?.width,
                                              }}
                                              label={column.name}
                                            />
                                          )}
                                        />
                                      )}
                                    {editIndex.rowIndex !== index &&
                                      !options?.isLoading &&
                                      column.edit?.(row) === false &&
                                      (updatedColumn.options?.customCell?.(
                                        row[column.id]
                                      ) ||
                                        updatedColumn?.calculatedField?.(
                                          row,
                                          rowCopy
                                        ) ||
                                        row[column.id])}

                                    {!options?.isLoading &&
                                      column.edit?.(row) === false &&
                                      editIndex.rowIndex === index &&
                                      (updatedColumn.options?.customCell?.(
                                        row[column.id]
                                      ) ||
                                        updatedColumn?.calculatedField?.(
                                          rowCopy,
                                          row
                                        ) ||
                                        row[column.id])}
                                  </TableCell>
                                );
                              }
                            })}
                            <Actions
                              editIndex={editIndex}
                              index={index}
                              validate={validate}
                              row={row}
                              options={options}
                              setSaved={setSaved}
                              rowCopy={rowCopy}
                            />
                          </TableRow>
                        )}
                      </Draggable>
                    );
                  }
                })}

                {options.customRows || null}
              </div>
            </div>
          )}
        </Droppable>

        <Box sx={{ height: "80px" }}></Box>
        {options?.fob && (
          <Fab
            sx={{ position: "fixed", bottom: 45, right: 45 }}
            color="primary"
            aria-label="add"
            onClick={(e) => {
              options?.fob(setEditIndex, setRowCopy);
            }}
          >
            <AddIcon />
          </Fab>
        )}
        {options?.SpeedDial && (
          <SpeedDial
            ariaLabel="SpeedDial basic example"
            sx={{ position: "fixed", bottom: 45, right: 45 }}
            icon={<SpeedDialIcon />}
          >
            {options?.SpeedDial.actions?.map((action) => (
              <SpeedDialAction
                key={action.name}
                icon={action.icon}
                tooltipTitle={action.name}
                tooltipOpen={action.tooltipOpen}
                onClick={() => action.onClick(setEditIndex, setRowCopy)}
              />
            ))}
          </SpeedDial>
        )}
      </TableBody>
    </DragDropContext>
  );
}

export default Body;
